import React, { useState } from 'react';
import {
  CheckCircle2,
  XCircle,
  RefreshCw,
  Clock,
  MapPin,
  Sun,
  Users,
  Shield,
  Smartphone,
  AlertTriangle,
  ChevronDown,
  ChevronUp
} from 'lucide-react';

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// ReviewGate
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const ReviewGate = ({ execution, onApprove, onReject, onRegenerate, loading }) => {
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState('');

  const handleReject = () => {
    if (rejectReason.trim()) {
      onReject(rejectReason);
      setShowRejectModal(false);
      setRejectReason('');
    }
  };

  if (execution.status === 'approved') {
    return (
      <div className="bg-green-50 border border-green-200 rounded-lg p-4">
        <div className="flex items-center gap-2 text-green-700">
          <CheckCircle2 className="w-5 h-5" />
          <span className="font-medium">Execution approvata</span>
        </div>
      </div>
    );
  }

  if (execution.status === 'rejected') {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <div className="flex items-center gap-2 text-red-700">
          <XCircle className="w-5 h-5" />
          <span className="font-medium">Execution rigettata</span>
        </div>
        {execution.rejectionReason && (
          <p className="text-sm text-red-600 mt-2">{execution.rejectionReason}</p>
        )}
      </div>
    );
  }

  return (
    <>
      <div className="bg-white border border-gray-200 rounded-lg p-4">
        <h3 className="font-medium text-gray-800 mb-3">Revisiona Output</h3>
        <div className="flex gap-3">
          <button onClick={() => onApprove()} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50">
            <CheckCircle2 className="w-4 h-4" /> Approva
          </button>
          <button onClick={onRegenerate} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50">
            <RefreshCw className="w-4 h-4" /> Rigenera
          </button>
          <button onClick={() => setShowRejectModal(true)} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50">
            <XCircle className="w-4 h-4" /> Rigetta
          </button>
        </div>
      </div>

      {showRejectModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
            <h3 className="text-lg font-semibold mb-4">Motivo del Rigetto</h3>
            <textarea
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              placeholder="Spiega perchÃ© rigetti questa execution..."
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
              rows={4}
            />
            <div className="flex gap-3 mt-4">
              <button
                onClick={() => setShowRejectModal(false)}
                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">
                Annulla
              </button>
              <button
                onClick={handleReject}
                disabled={!rejectReason.trim()}
                className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50">
                Conferma Rigetto
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// EnvSpecCard â€” environment_specification object
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const LIGHTING_FIELDS = [
  { key: 'primary_light_source', label: 'Primary Light Source' },
  { key: 'light_direction',      label: 'Light Direction' },
  { key: 'light_quality',        label: 'Light Quality' },
  { key: 'light_motivation',     label: 'Light Motivation' },
];

const LightingConditionsCard = ({ spec = {} }) => {
  const lc = spec.lighting_conditions || {};
  const [expanded, setExpanded] = useState(true);

  return (
    <div className="rounded-lg border border-rose-200 overflow-hidden">
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between p-3 bg-rose-50 hover:opacity-90 transition-opacity">
        <div className="flex items-center gap-2">
          <Sun className="w-4 h-4 text-rose-700" />
          <span className="text-xs font-semibold uppercase tracking-wide text-rose-700">Lighting Conditions</span>
        </div>
        {expanded
          ? <ChevronUp className="w-4 h-4 text-rose-500 opacity-50" />
          : <ChevronDown className="w-4 h-4 text-rose-500 opacity-50" />}
      </button>

      {expanded && (
        <div className="bg-white p-4 space-y-4 border-t border-gray-100">
          {LIGHTING_FIELDS.map(({ key, label }) => (
            lc[key] ? (
              <div key={key} className="flex items-start gap-3">
                <div className="mt-0.5 p-1.5 bg-rose-50 rounded-md flex-shrink-0">
                  <Sun className="w-3.5 h-3.5 text-rose-600" />
                </div>
                <div>
                  <p className="text-xs font-medium text-gray-500">{label}</p>
                  <p className="text-sm text-gray-800 mt-0.5">{lc[key]}</p>
                </div>
              </div>
            ) : null
          ))}

          {Array.isArray(lc.forbidden_lighting_patterns) && lc.forbidden_lighting_patterns.length > 0 && (
            <div>
              <p className="text-xs font-medium text-gray-500 mb-2">Forbidden Lighting Patterns</p>
              <ul className="space-y-1.5">
                {lc.forbidden_lighting_patterns.map((rule, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-gray-700">
                    <span className="text-rose-500 mt-0.5 font-bold">·</span>
                    {typeof rule === 'string' ? rule : JSON.stringify(rule)}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// SignalList â€” generic numbered list section
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const SignalList = ({ icon: Icon, title, items = [], colorClass, bgClass, borderClass }) => {
  if (!items.length) return null;
  return (
    <div className={`rounded-lg border ${borderClass} overflow-hidden`}>
      <div className={`flex items-center gap-2 p-3 ${bgClass}`}>
        <Icon className={`w-4 h-4 ${colorClass}`} />
        <span className={`text-xs font-semibold uppercase tracking-wide ${colorClass}`}>{title}</span>
        <span className="ml-auto text-xs text-gray-400">{items.length} items</span>
      </div>
      <ul className="divide-y divide-gray-100 bg-white">
        {items.map((item, i) => (
          <li key={i} className="flex items-start gap-3 p-3">
            <span className={`w-5 h-5 flex-shrink-0 flex items-center justify-center rounded-full text-xs font-bold ${colorClass} bg-gray-50 border border-current`}>
              {i + 1}
            </span>
            <p className="text-sm text-gray-700 leading-relaxed">
              {typeof item === 'string' ? item : JSON.stringify(item)}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// EmptyState
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const EmptyState = () => (
  <div className="flex items-center justify-center h-full">
    <div className="text-center text-gray-500">
      <Clock className="w-12 h-12 mx-auto mb-4 text-gray-300" />
      <p className="text-lg font-medium mb-2">In attesa di esecuzione</p>
      <p className="text-sm">Clicca "Esegui Contract" per avviare l'Environment & Context Design Engine</p>
    </div>
  </div>
);

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// Contract10View
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const Contract10View = ({ execution, onApprove, onReject, onRegenerate, loading }) => {
  if (!execution) return <EmptyState />;

  const output = execution.output || execution.outputData || {};
  const {
    environment_specification = {},
    socioeconomic_signals = [],
    privacy_signals = [],
    smartphone_plausibility = [],
    environmental_authenticity_rules = []
  } = output;

  return (
    <div className="h-full overflow-y-auto p-6">
      <div className="max-w-4xl mx-auto space-y-6">

        {/* Header */}
        <div>
          <div className="flex items-center gap-3 mb-1">
            <MapPin className="w-6 h-6 text-rose-600" />
            <h2 className="text-xl font-bold text-gray-800">Environment & Context Design</h2>
            <span className="px-2 py-0.5 text-xs bg-rose-100 text-rose-700 rounded-full font-medium">C10</span>
          </div>
          <p className="text-sm text-gray-500">
            Contesto ambientale e sociale della creativitÃ  â€” layer di plausibilitÃ  per tutti i moduli di produzione
          </p>
        </div>

        {/* Environment Specification */}
        <LightingConditionsCard spec={environment_specification} />

        {/* Signal Lists */}
        <div className="space-y-4">
          <SignalList
            icon={Users}
            title="Socioeconomic Signals"
            items={socioeconomic_signals}
            colorClass="text-amber-700"
            bgClass="bg-amber-50"
            borderClass="border-amber-200"
          />
          <SignalList
            icon={Shield}
            title="Privacy Signals"
            items={privacy_signals}
            colorClass="text-blue-700"
            bgClass="bg-blue-50"
            borderClass="border-blue-200"
          />
          <SignalList
            icon={Smartphone}
            title="Smartphone Plausibility"
            items={smartphone_plausibility}
            colorClass="text-indigo-700"
            bgClass="bg-indigo-50"
            borderClass="border-indigo-200"
          />
          <SignalList
            icon={AlertTriangle}
            title="Environmental Authenticity Rules"
            items={environmental_authenticity_rules}
            colorClass="text-red-700"
            bgClass="bg-red-50"
            borderClass="border-red-200"
          />
        </div>

        {/* Review Gate */}
        <ReviewGate
          execution={execution}
          onApprove={onApprove}
          onReject={onReject}
          onRegenerate={onRegenerate}
          loading={loading}
        />

      </div>
    </div>
  );
};

export default Contract10View;
